import { render } from "./Mailings.vue?vue&type=template&id=438703e5&scoped=true"
import script from "./Mailings.vue?vue&type=script&lang=js"
export * from "./Mailings.vue?vue&type=script&lang=js"

import "./Mailings.vue?vue&type=style&index=0&id=438703e5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-438703e5"

export default script